import React, { useEffect } from "react";
import Filter from "../filter";
import HorseCard from "components/horse-card";
import { horseFilter } from "store/horseFilter";

const HorsesCards = ({ data }) => {
  const { currentFilter } = horseFilter();

  const filter = (horse) => {
    if (!currentFilter) return true;

    const filteredValue = Object.keys(currentFilter).map((key) =>
      currentFilter[key] ? currentFilter[key] == horse[key] : true
    );

    return filteredValue.every((val) => val == true);
  };

  return (
    <div className="container">
      <div className="">
        <h1 className="header text-center">{data.title}</h1>
        <p className="mt-3 paragraph text-center text-gray-600">
          {data.description}
        </p>
      </div>
      {data.hasFilter && <Filter />}
      <div className="grid grid-cols-3 gap-5 mt-6 sm:grid-cols-1 md:grid-cols-2 ">
        {data.horseCards
          .filter((horse) => filter(horse))
          .map((horse, index) => {
            if (!horse?.sanity_visible) return null;
            return (
              <HorseCard key={index} data={horse} />
            )
          })}
      </div>
    </div>
  );
};

export default HorsesCards;
